import { createSelector } from '@reduxjs/toolkit'
import { createStructuredSelector } from 'reselect'

// Check if this is necessary
import { extractAssembly } from 'shared/product_tabs/tab_assembly/utils/extracters';

const selectCurrentVariant = (state) => state.usAssembly?.currentVariant;
const selectLoading = (state) => state.usAssembly?.loading;
const selectParameters = (state) => state.usAssembly?.parameters;
const selectQuote = (state) => state.usAssembly?.quote;
const selectQuoteStep = (state) => state.usAssembly?.quoteStep;
const selectParametersChanged = (state) => state.usAssembly?.parametersChanged;
const selectSuppliers = (state) => state.usAssembly?.suppliers;
const selectDestroy = (state) => state.usAssembly?.destroy;
const selectLineItemId = (state) => state.usAssembly?.lineItemId;
const selectAssemblyValidatorFlag = (state) => state.usAssembly?.validatorFlag;
const selectZipFileInputId = (state) => state.usAssembly?.zip_file_input_id;

export const selectAssemblyLoading = createStructuredSelector({
  loading: selectLoading,
  quoteStep: selectQuoteStep,
})

export const selectAssemblyParameters = createStructuredSelector({
  parameters: selectParameters,
  validatorFlag: selectAssemblyValidatorFlag,
  quoteStep: selectQuoteStep,
})

export const selectAssemblyDataForMatrix = createStructuredSelector({
  parameters: selectParameters,
  quote: selectQuote,
  quoteStep: selectQuoteStep,
  parametersChanged: selectParametersChanged,
  suppliers: selectSuppliers,
})

export const selectAssemblyDataForQuote = createStructuredSelector({
  parameters: selectParameters,
  suppliers: selectSuppliers,
  variant: selectCurrentVariant,
})

export const selectAssemblyDataForValidate = createStructuredSelector({
  parametersChanged: selectParametersChanged,
  quoteStep: selectQuoteStep,
})

export const selectAssemblyDataForCart = createSelector([
    selectParameters,
    selectQuoteStep,
    selectQuote,
    selectDestroy,
    selectLineItemId,
    selectCurrentVariant,
    selectZipFileInputId,
  ],
  (
    parameters,
    quoteStep,
    quote,
    destroy,
    lineItemId,
    currentVariant,
    zip_file_input_id,
  ) => {
    // const data_for_forms = {quoteStep, assemblyVariant: currentVariant, parameters, zip_file_input_id}

    return {
      assemblyProps: extractAssembly({ quoteStep, parameters, quote }),
      // assemblyDataForForms: data_for_forms,
    }
  }
)
